import Toast from "_common/toast";

export const copyToClipboard = data => {
	if ( !data ) return;

	navigator?.clipboard?.writeText ( data ).then ( function () {
		Toast.info ( "Copied to clipboard" );
	} );
};
